<template>
    <div class="flex flex-col min-h-0 w-full">
        <template v-for="(item, idx) of items" :key="`noti-${idx}`">
            <NotificationItem :item="item"></NotificationItem>
        </template>
    </div>
</template>
<script>
import NotificationItem from './NotificationItem.vue'

export default {
    name: 'NotificationList',
    props: {
        isOn: {
            type: Boolean,
            default: false
        },
        items: {
            type: Array,
            default: () => []
        }
    },
    components: { NotificationItem },
}
</script>
